import { render, staticRenderFns } from "./TeamCardList.vue?vue&type=template&id=06af8b48&scoped=true"
import script from "./TeamCardList.vue?vue&type=script&lang=js"
export * from "./TeamCardList.vue?vue&type=script&lang=js"
import style0 from "./TeamCardList.vue?vue&type=style&index=0&id=06af8b48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06af8b48",
  null
  
)

export default component.exports